export const types = {
    // Sync
    SET_USER: "SET_USER",
    LOGOUT: "LOGOUT",    

    // Async    
    LOGIN_ASYNC: "LOGIN_ASYNC",
    UPDATE_PROFILE_ASYNC: "UPDATE_PROFILE_ASYNC",
    UPDATE_SHIPPING_ADDRESS_ASYNC: "UPDATE_SHIPPING_ADDRESS_ASYNC",
    LOGIN_FACEBOOK_ASYNC: "LOGIN_FACEBOOK_ASYNC",
    REGISTER_ASYNC: "REGISTER_ASYNC",
    LOGOUT_ASYNC: "LOGOUT_ASYNC",    
    AUTHENTICATE_ASYNC: "AUTHENTICATE_ASYNC",
    
};
